const formatOpacity = (val) => {
  if (val >= 10) {
    return 1;
  } else {
    return `0.${val}`;
  }
};

export default formatOpacity;
